/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AdminPermission {
    SUPER_ADMIN = 'SuperAdmin',
    ADMIN_MANAGEMENT = 'AdminManagement',
    TRANSACTIONS = 'Transactions',
    TOP_MERCHANTS = 'TopMerchants',
    TOP_CUSTOMERS = 'TopCustomers',
    INSIGHTS = 'Insights',
    APP_PERFORMANCE = 'AppPerformance',
    KPIREPORT = 'KPIReport',
    PARTNER_MANAGEMENT = 'PartnerManagement',
    VISA = 'Visa',
    BILLING = 'Billing',
    WEBSHOP = 'Webshop',
    NOTIFICATIONS = 'Notifications',
    PARTNER_NETWORK_REPORT = 'PartnerNetworkReport',
    ANALYTICS = 'Analytics',
    FEATURED_PARTNERS = 'FeaturedPartners',
    REVENUE_SHARING_REPORT = 'RevenueSharingReport',
    FAILED_TRANSACTIONS = 'FailedTransactions',
    OFFLINE_TRANSACTIONS = 'OfflineTransactions',
    USERS = 'Users',
    CASHBACK_REQUESTS = 'CashbackRequests',
    ERASURES = 'Erasures',
    PROMO_CODES = 'PromoCodes',
    SEARCH_SUGGESTIONS = 'SearchSuggestions',
    POPUP_CAMPAIGNS = 'PopupCampaigns',
    OPT_IN_OFFERS = 'OptInOffers',
}
